import React, { useState } from "react";
import { EyeInvisibleOutlined, EyeOutlined } from "@ant-design/icons";
import { useDispatch } from "react-redux";
import { serverFetch } from "../../core/server";
import { clearUserSession, setUserSession } from "../../store/user-slice";
import ellipseBrSrc from "./assets/ellipse-br.svg";
import ellipseTlSrc from "./assets/ellipse-tl.svg";
import logoSrc from "./assets/logo.svg";
import "./auth.css";

const REMEMBER_LOGIN_KEY = "authRememberLogin";

const Auth = () => {
  const dispatch = useDispatch();
  const [login, setLogin] = useState(
    () => localStorage.getItem(REMEMBER_LOGIN_KEY) || "admin"
  );
  const [password, setPassword] = useState("admin");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const onSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    setError("");

    try {
      const session = await serverFetch("auth/login", {
        method: "POST",
        bodyData: { login, password }
      });
      localStorage.setItem("sessionId", session.sessionId);
      localStorage.setItem(REMEMBER_LOGIN_KEY, login);
      dispatch(
        setUserSession({
          sessionId: session.sessionId,
          userId: session.userId,
          name: session.userName,
          companyId: session.companyId,
          depId: session.depId,
          isAdmin: session.isAdmin,
          level: session.level,
          law: session.law,
          dolj: session.dolj,
          login
        })
      );
    } catch (e) {
      localStorage.removeItem("sessionId");
      dispatch(clearUserSession());
      setError(e.message || "Ошибка авторизации");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-body">
      <aside className="auth-left">
        <div className="auth-ellipse auth-ellipse--tl">
          <img src={ellipseTlSrc} alt="" />
        </div>
        <div className="auth-ellipse auth-ellipse--br">
          <img src={ellipseBrSrc} alt="" />
        </div>
        <div className="auth-left-content">
          <h1 className="auth-left-title">
            Управляйте
            <br />
            курортным бизнесом
            <br />
            эффективно
          </h1>
          <p className="auth-left-lead">
            Единая онлайн платформа для отелей, гостиниц и санаториев
          </p>
          <div className="auth-stats">
            <div className="auth-stat">
              <div className="auth-stat-value">140+</div>
              <div className="auth-stat-label">Санаториев</div>
            </div>
            <div className="auth-stat">
              <div className="auth-stat-value">650+</div>
              <div className="auth-stat-label">Номеров</div>
            </div>
            <div className="auth-stat">
              <div className="auth-stat-value">1.2 млн</div>
              <div className="auth-stat-label">Пациентов</div>
            </div>
          </div>
        </div>
      </aside>

      <main className="auth-right">
        <form className="auth-form" onSubmit={onSubmit}>
          <div className="auth-logo">
            <img src={logoSrc} alt="" />
          </div>
          <p className="auth-brand">ПРОФФИТЕЛЬ</p>
          <h2 className="auth-title">Вход в систему</h2>

          <label className="auth-field">
            <span className="auth-label">Логин</span>
            <input
              className="auth-input"
              type="text"
              name="login"
              autoComplete="username"
              placeholder="admin"
              value={login}
              onChange={(e) => setLogin(e.target.value)}
              disabled={loading}
              required
            />
          </label>

          <label className="auth-field">
            <span className="auth-label">Пароль</span>
            <div className="auth-input-wrap">
              <input
                className="auth-input"
                type={showPassword ? "text" : "password"}
                name="password"
                autoComplete="current-password"
                placeholder="••••••••"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                disabled={loading}
                required
              />
              <button
                className="auth-eye"
                type="button"
                aria-label={showPassword ? "Скрыть пароль" : "Показать пароль"}
                onClick={() => setShowPassword((value) => !value)}
              >
                {showPassword ? <EyeInvisibleOutlined /> : <EyeOutlined />}
              </button>
            </div>
          </label>

          <button className="auth-btn" type="submit" disabled={loading}>
            {loading ? "Вход..." : "Войти"}
          </button>
          <div className="auth-error">{error}</div>
        </form>
        <p className="auth-copy">© 2026 Проффитель. Все права защищены.</p>
      </main>
    </div>
  );
};

export default Auth;
